<!--
 * @Author: lan.h
 * @Date: 2022-02-23 10:02:47
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-23 17:25:55
 * @Description: 右侧模板
-->
<template>
  <div class="right-model">
    <Affix :offset-top="offset_top" @on-change="affixChange" id="affix">
      <div class="data-nav" ref="right-nav" :style="'transform: translateY(' + translate_y + 'px);'">
        <slot></slot>
      </div>
    </Affix>
  </div>
</template>
<script>
export default {
  components: {},
  created() { },
  mounted() {
    this.$nextTick(() => {
      this.scrollChange()
      if (this.$route.name != 'reportingDetail') {
        window.onscroll = this.debounce(this.scrollChange, 10)
      }
    })
  },
  beforeDestroy() {
    window.onscroll = ''
  },
  data() { 
    return {
      offset_top: 0,
      translate_y: 0,
      is_affix: false
    }
  },
  methods: {
    /**
     * @description: 滚动条防抖
     * @param {*} fn
     * @param {*} wait
     * @return {*}
     */
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    scrollChange() {
      let footer_height = document.getElementById('home-footer').offsetHeight
      let header_height = document.getElementById('home-header').offsetHeight
      let scroll_top = document.documentElement.scrollTop || document.body.scrollTop //滚动条的值
      let y = scroll_top + window.innerHeight + footer_height - document.body.clientHeight
      this.translate_y = y > -1 ? 0 - y : 0

      let num = window.innerHeight - this.$refs['right-nav'].offsetHeight - 20
      this.offset_top = num > header_height ? (header_height + 20) : num
      let affix_dom = document.querySelector('#dara-affix .ivu-affix')
      if(!affix_dom) return
      if(this.is_affix){
        affix_dom.style.top = this.offset_top + 'px'
        affix_dom.style.left = 'auto'
      } else {
        affix_dom.style.top = 'auto'
        affix_dom.style.left = 'auto'
      }
    },
    affixChange(val) {
      this.is_affix = val
    }
  }
}
</script>
<style lang="stylus">
.right-model
  width 100%
  .data-nav
    >div
      margin-top 30px
    >div:nth-child(1)
      margin-top 0
</style>